var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 304,
    viewBox: "0 0 451 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.95 18.6381L79.7239 83.6323L60.5813 88.916V112.882C60.3842 116.222 63.1031 119.594 68.7104 122.137L186.281 175.546C197.068 180.438 214.718 180.437 225.504 175.545L382.39 104.385C388.172 101.762 390.855 98.2447 390.437 94.7921L390.481 94.8119V70.3161L368.488 80.2915L276.103 18.6381C265.317 13.7464 231.736 13.7458 220.95 18.6381Z",
    fill: "#90CAF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.497 8.89503L68.6108 80.0551C57.8249 84.9473 57.9232 92.9079 68.7096 97.7996L186.281 151.208C197.067 156.1 214.717 156.1 225.503 151.207L382.389 80.0472C393.175 75.155 393.175 67.1499 382.388 62.2582L264.719 8.89405C253.933 4.00234 236.283 4.00277 225.497 8.89503ZM264.72 26.6831L235.306 84.4982L107.834 97.8431L88.2223 88.9491L215.694 75.6041L245.109 17.7891L264.72 26.6831Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.497 8.89503L68.6108 80.0551C57.8249 84.9473 57.9232 92.9079 68.7096 97.7996L186.281 151.208C197.067 156.1 214.717 156.1 225.503 151.207L382.389 80.0472C393.175 75.155 393.175 67.1499 382.388 62.2582L264.719 8.89405C253.933 4.00234 236.283 4.00277 225.497 8.89503ZM264.72 26.6831L235.306 84.4982L107.834 97.8431L88.2223 88.9491L215.694 75.6041L245.109 17.7891L264.72 26.6831Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.24 85.8807L268.654 28.0656L249.043 19.1716L219.628 76.9867L92.1562 90.3317L111.768 99.2257L239.24 85.8807Z",
    fill: "#E3F2FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.571289,
    y: 14.9691,
    width: 449.91,
    height: 288.245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.396079 0 0 0 0 0.752941 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 59.0862,
    y1: 80.0511,
    x2: 232.865,
    y2: 228.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetMail);
export default __webpack_public_path__ + "static/media/widget-mail.209bf8c6f9d08929ddd37b2a9000ca95.svg";
export { ForwardRef as ReactComponent };